import script from "./MindMapView.vue?vue&type=script&setup=true&lang=js"
export * from "./MindMapView.vue?vue&type=script&setup=true&lang=js"

import "./MindMapView.vue?vue&type=style&index=0&id=54816da0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54816da0"]])

export default __exports__